var _path, _path2, _path3, _rect, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 77,
    fill: "none",
    viewBox: "0 0 83 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#131324",
    d: "M26.004 4.963h32.938c1.11 0 2.011.9 2.011 2.011V76.15h-36.96V6.974c0-1.11.9-2.011 2.01-2.011z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#131324",
    fillRule: "evenodd",
    d: "M44.77 25.382a.313.313 0 0 1-.228.098.314.314 0 0 1-.23-.098.314.314 0 0 1-.097-.23c0-.086.032-.163.098-.228a.314.314 0 0 1 .457 0 .314.314 0 0 1 0 .458zm-2.592 2.713v-1.283c0-.15.045-.272.134-.364a.457.457 0 0 1 .344-.139c.14 0 .256.047.344.139a.503.503 0 0 1 .134.364v1.283h.578v-1.358c0-.15-.023-.287-.068-.407a.894.894 0 0 0-.191-.31.824.824 0 0 0-.294-.196 1.012 1.012 0 0 0-.641-.027 1.425 1.425 0 0 0-.204.085 1.2 1.2 0 0 0-.186.126l-.1-.226H41.6v2.313h.578zm-2.313.025a.874.874 0 0 0 .261-.038 1.208 1.208 0 0 0 .392-.214l.101.227h.428v-2.313h-.578v1.282c0 .15-.045.272-.134.364a.457.457 0 0 1-.344.139.457.457 0 0 1-.345-.139.503.503 0 0 1-.133-.364v-1.282h-.578v1.357c0 .151.022.287.068.408.045.12.109.223.19.309.083.085.18.15.295.196.114.045.24.068.377.068zm4.953-.025v-2.313h-.578v2.313h.578zm1.705 0a.834.834 0 0 1-.51-.033.68.68 0 0 1-.247-.169.796.796 0 0 1-.16-.261.949.949 0 0 1-.059-.342v-.98h-.351v-.478h.15c.185 0 .277-.092.277-.277v-.327h.503v.553h.503v.529h-.503v.955c0 .1.03.18.088.239a.322.322 0 0 0 .239.088.676.676 0 0 0 .11-.01.193.193 0 0 0 .04-.015v.503a.452.452 0 0 1-.08.025z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#131324",
    d: "M23.364.503h38.218a4.023 4.023 0 0 1 4.023 4.023V76.15H19.34V4.526A4.023 4.023 0 0 1 23.364.503z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82.526,
    height: 1,
    fill: "#131324",
    rx: 0.5,
    transform: "matrix(1.00574 0 0 -1.00574 0 76.653)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#131324",
    d: "M49.784 45.192h5.029a1.509 1.509 0 0 1 0 3.017h-5.029a1.509 1.509 0 0 1 0-3.017z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitIcon);
export default __webpack_public_path__ + "static/media/unit-icon.6b11831b83d85ffb102ab01aa79be32e.svg";
export { ForwardRef as ReactComponent };